import * as z from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {PrimerComponentFaqSchema} from './primerComponentFaq'
import {AccordionToggleColors} from '@primer/react-brand'
import {safeOptional} from '../../safe-optional'

export const PrimerComponentFaqGroupSchema = buildEntrySchemaFor('primerComponentFaqGroup', {
  fields: z.lazy(() =>
    z.object({
      heading: z.string(),
      faqs: safeOptional(z.array(PrimerComponentFaqSchema)),
      htmlId: z.string().optional(),
      plusIconColor: z.enum(AccordionToggleColors).optional(),
    }),
  ),
})

export type PrimerComponentFaqGroup = z.infer<typeof PrimerComponentFaqGroupSchema>
